import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorConfigurationAnalyticsSummary } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseQueryOptions<SensorConfigurationAnalyticsSummary, Error>, 'queryKey' | 'queryFn'>
}

export const useSensorConfigurationAnalyticsSummaryRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<SensorConfigurationAnalyticsSummary, Error>(
    [Entities.SensorConfigurationAnalyticsSummary],
    async () => {
      const { data } = await api.v1AdminSensorsConfigurationAnalyticsSummaryGet()
      return data as SensorConfigurationAnalyticsSummary
    },
    options
  )
}
